export const UNGROUPED_DEVICE_GROUP_ID = '00000000-4444-4444-4444-000000000000';
export const UNGROUPED_FORMS_GROUP_ID = '00000';
export const UNGROUPED_APP_GROUP_ID = '00000000-6666-6666-6666-000000000000';
export const UNGROUPED_NAMING_GROUP_ID = '00000000-1337-000000000000';
